import { t as localeText } from "@/i18n/translate";
import { useTranslation as useLocaleSubscription } from "react-i18next";
import { useState } from "react";
import { Button, TextLink } from "@/shared/ui";
import { DownloadIcon } from "@/shared/ui/icons";
import { getThreeDDownload } from "./threeDAssets";
import type { ThreeDAsset } from "./threeDState";

export function ThreeDDownloadButton({ asset }: { asset: ThreeDAsset }) {
  useLocaleSubscription();
  const [pending, setPending] = useState(false); const [error, setError] = useState(false);
  return <div><Button variant="outline" loading={pending} disabled={!asset.can_download} onClick={() => {
    setPending(true); setError(false);
    void getThreeDDownload(asset).then(item => {
      const link = document.createElement("a"); link.href = item.url; link.download = item.name; link.rel = "noopener noreferrer";
      document.body.appendChild(link); link.click(); link.remove();
    }).catch(() => setError(true)).finally(() => setPending(false));
  }}><DownloadIcon />{localeText("interface.download_original_glb_daf5f729", { defaultValue: "Download original GLB" })}</Button>{error ? <p className="three-d-field-error" role="status">{localeText("interface.download_couldn_t_start_ac1d1b55", { defaultValue: "Download couldn’t start." })} <TextLink href={`/assets?asset=${encodeURIComponent(asset.id)}`}>{localeText("interface.open_the_original_in_assets_709febc7", { defaultValue: "Open the original in Assets" })}</TextLink></p> : null}</div>;
}
